import { Base } from "//www.greenwellfarms.com/cdn/shop/t/53/assets/base.js?v=169946323862693207411733340615";
import { ProductRCSingle } from "//www.greenwellfarms.com/cdn/shop/t/53/assets/product-rc-single.js?v=114309847660164520131733759483";

import Glide, {
    Controls,
    Breakpoints,
    Swipe,
    Autoplay
} from "//www.greenwellfarms.com/cdn/shop/t/53/assets/glide.modular.esm.js?v=110347022713276517591733338766";

class ProductRecommendation extends Base {
    init(selector) {

        selector = this.prep_selector(selector, {classes: ["wrapper", "product-rc-wrapper" ]});

        this.set("el", selector);
        return this.prep();

    }

    prep() {
     

        this.load_style("glide_core_css", "//www.greenwellfarms.com/cdn/shop/t/53/assets/glide.core.css?v=159628661736970293241733338766");
        this.load_style("glide_theme_css", "//www.greenwellfarms.com/cdn/shop/t/53/assets/glide.theme.css?v=73557774067224775451733338766");

        return this.fetch_data().bind_events();
    }

    fetch_data(){

        let the_item = this.get("el");

        this.do_waiting(the_item);
        fetch(the_item.dataset.url)
            .then(res => res.json())
            .then(data => this.done_fetching_data(data))
            .catch(err => this.failed_fetching_data);

        return this;
    }

    done_fetching_data(the_data){
        let the_item = this.get("el");

        this.done_waiting(the_item);
        this.set("data", the_data.products || []);
        return this.handle_data();
    } 

    failed_fetching_data(the_error){
        let the_item = this.get("el");

        console.log("error: ", the_error);
        this.done_waiting(the_item);
        return this;
    }


    handle_data(){
        let the_data  = this.get("data");
        if(null === the_data || the_data.length === 0) return this;
        this.prep_glide_component();
        the_data.forEach(s => this.add_single(s));
        return this.run_hooks("product-rc-ready");
    } // done handling data


    prep_glide_component(){

        let the_item = this.get("el"), 
            slider = document.createElement("div"), 
            slide_control_prev = document.createElement("div"), 
            slide_control_next = document.createElement("div"), 
            slider_track = document.createElement("div"),
            list_container = document.createElement("div");



        slider.classList.add("wrapper", "slider-wrapper", "glide");

        slider_track.classList.add("prc-slider-track", "glide__track");
        slider_track.setAttribute("data-glide-el", "track");
        list_container.classList.add("prc-list-container", "glide__slides", "ft-glife__slides");

        slider_track.append(list_container);

        slide_control_prev.innerHTML = ` <button title='Next' class="glide__arrow--prev" data-glide-dir="<"><span class='btn-text'>Prev</span></button>`;
        slide_control_next.innerHTML = ` <button title='Previous' class="glide__arrow--next" data-glide-dir=">"><span class='btn-text'>Next</span></button> `;
        slide_control_prev.setAttribute("data-glide-el", "controls");
        slide_control_next.setAttribute("data-glide-el", "controls");

        slider.append(slide_control_prev);
        slider.append(slider_track);
        slider.append(slide_control_next);

        this.get_container().append(slider);

        the_item.list_container = list_container;
        the_item.slider = slider;

        return this;

    } // more prep

    add_single(s){

        let list_container = this.get("el").list_container, 
            single = new ProductRCSingle();
            single.init();
        
        single.title = s.title;
        single.set_link(s.url.split("?")[0]);
        single.image = s.images[0];
        single.set_description(this.clean_tags(s.description));
        single.price = (null === s.price_min || null === s.price_max || s.price_max === s.price_min) ? 
            (this.to_money(parseFloat(s.price) / 100)) : 
            (this.to_money(parseFloat(s.price_min) / 100) + " - " + this.to_money(parseFloat(s.price_max) / 100));
        list_container.append(single.get_dom());

        return this;
    }

    bind_events() {

        this.add_hooks("product-rc-ready", () => {
            // console.log(">>> glide js activate");
            let glide = new Glide(this.get("el").slider, {
                    type: "carousel",
                    focusAt: 0,
                    startAt: 0,
                    rewind: false,
                    gap: 0,
                    perView: 4,
                    autoplay: 0,
                    peek: {
                        before: 0, 
                        after: 0
                    },
                    animationDuration: 1000,
                    breakpoints: {
                        568: {
                            perView: 1,
                        },
                        768: {
                            perView: 2,
                        },
                        968: {
                            perView: 3,
                        }
                    },
                });
        
            glide.mount({
                Controls,
                Breakpoints,
                Swipe
            });

        });

        return this;

    }

}

export { ProductRecommendation };
